import { AdvertiserInsertionOrderCollection } from '@features/users/adminPanel/services/advertiserInsertionOrders/service.types';
import { MsGraphApiResponse } from '@shared/api/commonApiInterfaces';
import { DataStatuses } from '@shared/types/common';

export const mockedAdvertiserInsertionOrdersData: MsGraphApiResponse<AdvertiserInsertionOrderCollection> = {
  items: [
    {
      id: '1',
      companyName: 'Test Advertiser',
      vatNumber: '123456789',
      invoicingEmail: 'test@example.com',
      status: DataStatuses.IN_APPROVAL,
      email: 'test@example.com',
    },
    {
      id: '2',
      companyName: 'Another Advertiser',
      vatNumber: '987654321',
      invoicingEmail: 'another@example.com',
      status: DataStatuses.APPROVED,
      email: 'another@example.com',
    },
  ],
};
